import {
  canUseTemaTools,
  isSubscriptionFunctionalityOff,
} from "../utils/subscriptionAccess";
import {
  DEFAULT_TEACHER_PERMISSIONS,
  TEMA_PERMISSIONS,
  TEMA_ROLES,
  TEMA_ROUTE_IDS,
} from "./temaRouteConstants";

const ROUTES_ALLOWED_WHEN_TEMA_INACTIVE = new Set([
  TEMA_ROUTE_IDS.DASHBOARD,
  TEMA_ROUTE_IDS.BILLING,
]);

export function isRouteAllowedWhenTemaInactive(routeId) {
  return ROUTES_ALLOWED_WHEN_TEMA_INACTIVE.has(routeId);
}

export function getTeacherPermissions(isAuthenticated) {
  if (!isAuthenticated) {
    return [];
  }

  return DEFAULT_TEACHER_PERMISSIONS;
}

export function getTeacherRole(isAuthenticated) {
  return isAuthenticated ? TEMA_ROLES.TEACHER : null;
}

export function hasRoutePermission(route, permissions = []) {
  if (!route?.permissions?.length) {
    return true;
  }

  return route.permissions.every((permission) => permissions.includes(permission));
}

export function canAccessRoute(
  route,
  { isAuthenticated, permissions, subscription } = {},
) {
  if (!route) {
    return false;
  }

  if (route.requiresAuth && !isAuthenticated) {
    return false;
  }

  if (
    !isSubscriptionFunctionalityOff() &&
    isAuthenticated &&
    !canUseTemaTools(subscription) &&
    !isRouteAllowedWhenTemaInactive(route.id)
  ) {
    return false;
  }

  return hasRoutePermission(route, permissions);
}

export { TEMA_PERMISSIONS, TEMA_ROLES, DEFAULT_TEACHER_PERMISSIONS };
